import { Box } from "@mui/system";
import MissingDataFilter from "./MissingDataFilter";
import MissingDataCardItem from "./MissingDataCardItem";

const MissingData = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <MissingDataFilter />
        <MissingDataCardItem/>
      </Box>
    </>
  );
};

export default MissingData;
